import { FunctionComponent } from 'react';
import { MenuViewModel } from '../../models/MenuViewModel';
import SubMenu from './SubMenu';

const SubMenuForm: FunctionComponent<MenuViewModel> = props => <SubMenu {...props} alignment="pagemenu-align-left" />;

export default SubMenuForm;
